import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
//import jsforce from "jsforce";
import HtmlParser from 'html-react-parser';
import { Formik } from "formik";
import { mailDomainsBlacklist } from '../utils/utils.js';

const PORTAL_ID = '7284441';
const FORM_ID = '3ef92e07-5990-4e65-aee7-03fe0ef320ef';

function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
}

export class DemoFormShort extends React.Component {
  state = { error: false,  mailError: false, submitted: false };

  validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Must be a valid email")
      .matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required")
  });

  handleSubmit = async (values, { resetForm }) => {
    values.source = this.props.source ? this.props.source : HtmlParser("");
    // console.log(values)
    const url = typeof window !== 'undefined' ? window.location.href : '';
    const pageTitle = typeof document !== 'undefined' ? document.title : '';


    const UTMparams = JSON.parse(sessionStorage.getItem('UTMparams'));

    const fields = [ {name: 'email', value: values.email} ]

    if (UTMparams && typeof UTMparams[0] === "string" ){
      fields.push({name: UTMparams[0], value: UTMparams[1]})

    } else if (UTMparams) {
      UTMparams.forEach(property => {
        fields.push({name: property[0], value: property[1]})
      })
    }

    const context = {
      pageUri: url,
      pageName: pageTitle
    }

    try {
      // ============ Sending to Hubspot ============ // 
      await axios.request({
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
        data: JSON.stringify({
          fields: fields,
          context: context
        })
      })
      
      this.setState({ submitted: true });
    
    } catch (error) {
      this.setState({ error: true })
      return
    }

    // ============ Sending to Charthop API (Slack) ============ //
    await axios.request({
      method: "POST",
      url: "https://api.charthop.com/contact",
      data: {...values}
    })

  };


  render() {
    const source = this.props.source ? this.props.source : HtmlParser("");

    if (this.state.submitted) {
      return (
        <div className="pt-callout pt-intent-primary" style={{ marginTop: 20 }}>
          <span role="img" aria-label="success">&#9989;</span> Thanks for your interest in ChartHop! We'll reach out with next steps.        </div>
      );
    }
    return (
      <Formik
        initialValues={{ email: "" }}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={form => (
          <form
            className="demoshortform"
            onSubmit={form.handleSubmit}
          >

            <div className="inputrow">
              <div className="pt-form-group hiddenForm mt-0">
                <input
                  type="hidden"
                  value={source}
                />
              </div>
              <div className={toFormGroupClass("email", form)} >
                <label className="pt-label" htmlFor="email">
                  Company Email
              </label>
                <input
                  id="emailshort"
                  name="email"
                  type="text"
                  className="companyEmail"
                  value={form.values.email}
                  onChange={form.handleChange}
                  placeholder="Company Email"
                />
                {form.touched.email && form.errors.email && (
                  <div className="pt-form-helper-text">{form.errors.email}</div>
                )}

              </div>

              <button type="submit" className="button primary">
                REQUEST A DEMO
              </button>
            </div>
            
            {this.state.mailError && (
              <div
                className="pt-callout pt-intent-danger"
                style={{ marginTop: 10 }}
              >
                <span role="img" aria-label="warning">&#128680;</span>
                Sorry! Please use a company email. If your issue persists, send a note to {" "}
                <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
              </div>
            )}


            {this.state.error && (
              <div
                className="pt-callout pt-intent-danger"
                style={{ marginTop: 10 }}
              >
                <span role="img" aria-label="warning">&#128680;</span>
                Sorry, but we had an unexpected problem submitting your request.
                Try again later, or send a note to{" "}
                <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
              </div>
            )}
          </form>

        )}
      />
    );
  }
}
